export default {
  translation: {
    translation_eng: 'en',
    translation_zhHant: 'zhHant',
    lang_eng: 'ENGLISH',
    lang_zhHant: '繁中',
    wallet: 'Payment System',
    add_value: 'Add Value',
    payment: 'Payment',
    account_record: 'Account Record',
    my_balance: 'My Balance',
    hkd: 'HKD',
    bank_transfer: 'Bank Transfer',
    bank_slip: 'Bank Slip',
    select_image: 'Select Image',
    confirm: 'Confirm',
    cancel: 'Cancel',
    in_progress: 'In Progress',
    completed: 'Completed',
    cancelled: 'Cancelled',
    invoice: 'Invoice',
    invoice_no: 'Invoice #',
    loading: '',
    pull_down_to_refresh: 'Pull down to refresh',
    release_to_refresh: 'Release to refresh',
    not_enough_value: 'Not Enough Value',
    online_add_value: 'Online Add Value',
    other_payment_method: 'Other Payment Method',
    spc_wallet: 'SPC Credit',
    alipay: 'Alipay',
    wechat_pay: 'WeChat Pay',
    fps: 'FPS',
    payme: 'PayMe',
    paypal: 'PayPal',
    paypal_auth: 'PayPal',
    edda: 'eDDA',
    credit_card: 'Credit Card',
    new_credit_card: 'New Credit Card',
    payee_bank_name: 'English Full Name Displayed on Bank Account',
    total: 'Total',
    payment_deadline: 'Payment Deadline',
    no_payment_record: 'No Payment Record',
    spc_wallet_not_enough_msg:
      'The remaining value of your SPC Wallet is not enough. Would you like to add value to your SPC Wallet?',
    which_payment_method_msg: 'Which payment method would you like to use?',
    which_credit_card_msg: 'Which Credit Card would you like to use?',
    amount: 'Amount',
    custom: 'Custom',
    expiry_date: 'Expiry Date',
    cvv: 'CVV',
    credit_card_number: 'Credit Card Number',
    expense: 'EXPENSE',
    redeem: 'DEPOSIT',
    refund: 'REFUND',
    error: 'Error',
    ok: 'OK',
    service_charge: 'Service Charge',
    item_total: 'Item Total',
    cms: 'CMS',
    login: 'LOGIN',
    cms_school_calender: 'School Calender',
    cms_timetable: 'Timetable',
    cms_user_list: 'User List',
    cms_user_list_class: 'Class List',
    cms_user_list_group: 'Group List',
    cms_user_list_chat_group: 'Chat Group List',
    cms_user_list_student: 'Student List',
    cms_user_list_parent: 'Paren List',
    cms_user_list_teacher: 'Teacher List',
    cms_user_list_admin: 'Admin List',
    cms_management: 'Management',
    cms_class_management: 'Class Management',
    cms_group_management: 'Group Management',
    cms_subject_management: 'Subject Management',
    cms_attendance_system: 'Attendance System',
    cms_reply_slip: 'Reply Slip',
    cms_payment_system: 'Payment System',
    cms_payment_system_add_value: 'Add Value',
    cms_payment_system_add_value_record: 'Add Value Record',
    cms_payment_system_payment_record: 'Payment Record',
    cms_payment_system_reply_slip_management: 'Reply Slip Management',
    cms_payment_system_account_management: 'Account Management',
    cms_daily_verse: 'Daily Verse',
    cms_school_news: 'School News',
    cms_library: 'Library',
    cms_school_tv: 'School TV',
    cms_promotion: 'Promotion',
    cms_mobile_theme: 'Mobile Theme',
    cms_description: 'Description',
    cms_agenda: 'Agenda',
    add_value_amount: 'Add Value Amount',
    student_number: 'Student Number',
    student_chinese_name: 'Student Chinese Name',
    student_english_name: 'Student English Name',
    class_number: 'Class Number',
    class_id: 'Class',
    remove: 'Remove',
    preview: 'Preview',
    photo: 'Photo',
    select_files: 'Select files...',
    reset_password: 'Reset Password',
    enter_new_password: 'Enter New Password',
    balance: 'Balance',
    authority: 'Authority',
    access: 'Access',
    success: 'Success',
    fail: 'Fail',
    manual_validate: 'Validate Manually',
    payment_success: 'Successfully Paid',
    payment_fail: 'Fail to validate your payment, please wait and try to validate again',
    paypal_validation_fail: 'Fail to validate your payment, please try again or change pay method',
    invoice_paying_notice: 'We are validating your payment status, please wait',
    invoice_paid_notice: 'You have paid successfully. Following is your payment record',
    invoice_auth_notice: 'We have held your money for the following items',
    invoice_cancel_notice: 'Invoice has been cancelled',
    invoice_expired: 'Invoice Expired',
    fps_tutor_name_same: 'Bank Account Full Name: ',
    fps_tutorial:
      'Click and save the QR Code. Then import it to your personal banking APP for FPS pay.',
    fps_paid_notice: 'If you have already paid, please wait for the school verification.',
    change_method: 'Change Pay Method',
    change_method_notice: 'If you have already paid, please do not change the payment method. Otherwise, your successful payment will not able be verified.',
  },
}
